import { render, staticRenderFns } from "./index.vue?vue&type=template&id=71dfa007"
import script from "./gstr1ReturnSummary.js?vue&type=script&lang=js&external"
export * from "./gstr1ReturnSummary.js?vue&type=script&lang=js&external"
import style0 from "./gstr1ReturnSummary.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports